import cn from 'classnames';

import { CoreCardGridData } from 'src/types/components';

import RichText from 'components/BaseHelpers/RichText';
import Text from 'components/BaseHelpers/Text';

import GeneralCard from './GeneralCard/GeneralCard';

import styles from './CoreCardGrid.module.scss';

export type CoreCardGridProps = CoreCardGridData;

const CoreCardGrid = ({ fields }: CoreCardGridProps): JSX.Element => {
  const { header, generalCards, anchorTag } = fields;
  const { eyebrow, heading, description } = header;
  const displayHeader = !!eyebrow || !!heading || !!description;

  const customGridClass = generalCards.length <= 3 && styles['cardList--centered'];

  return (
    <section
      id={anchorTag}
      className={cn(styles.cardGrid, 'spacer', 'spacer--with-vertical-padding')}
    >
      <div className={cn('container', 'container--true-1440')}>
        {displayHeader && (
          <div className={styles.header}>
            {!!eyebrow && <Text tag="p" field={eyebrow} className={styles.eyebrow} />}
            {!!heading && <Text tag="h3" field={heading} className={styles.heading} />}
            {!!description && <RichText field={description} className={styles.description} />}
          </div>
        )}
        {generalCards.length > 0 && (
          <ul className={cn(styles.cardList, customGridClass)} aria-label="Card Navigation">
            {generalCards.map((card, index) => {
              return (
                <li key={`card-grid-${index}`} className={styles.cardItem}>
                  <GeneralCard {...card} />
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </section>
  );
};

export default CoreCardGrid;
